import axios from 'axios'

let token = null
// window.ikea.authentication.getTokens(console.debug)
// token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6ImVxSFFLR3duR3hfV3dJZkx0RGpaeDA5MTUzS2xSam5fVE1nVUlMYlJ5RncifQ.eyJpc3MiOiJodHRwczovL2FwaS5pbmdrYS5pa2VhLmNvbS9ndWVzdCIsInN1YiI6ImE5ODdjZDkyLTIwNDItNDRiZS1hMmVmLTk3NTczYWI1NmNmMyIsInJldGFpbFVuaXQiOiJ1cyIsImlhdCI6MTY1NDUzNjE5MywiZXhwIjoxNjU3MTI4MTkzfQ.ecEdeuAEcuXwYEmFDM2AQ1PVLm7tyBGRGFeDxS-YpApwOM-e-Yf20P0xGK7-kw-CXuAJQXJIK2XaCnj0NusAYb7SqrYJsMk9ROTxQVwTFhKlC-7xjzFxOtr3Gap5uSKEyoX-8UN-a2WCP5nUsSzBCiDABioeD_pdA1tabtk_zzQ"
export const hasToken = () => !!token

export const setSpiderpigsToken = (tokens) => {
    const now = Date.now()
    if (tokens.auth && tokens.auth.expirationTime < now) {
        token = tokens.auth.value
    } else if (tokens.guest && tokens.guest.expirationTime < now) {
        token = tokens.guest.value
    } else {
        // token = null
    }
}

const spiderpigsQuery = async (url, query, variables = {}) => {
    const resp = await axios({
        method: 'POST',
        url,
        headers: {
            Accept: 'application/json',
            'Content-type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Client-Id': SPIDERPIGS_CLIENT_ID,
        },
        data: {
            query,
            variables,
        },
    })

    if (resp.errors) {
        return Promise.reject(resp.errors)
    }
    return resp.data
}

export const getFavs = () =>
    spiderpigsQuery(
        SPIDERPIGS_LIST_API,
        `
            query {
                minimalLists {
                    listId
                    name
                    isSelected
                    items {
                        itemNo
                    }
                }
            }
        `,
    ).then(({ data }) =>
        data.minimalLists.map((l) => ({
            listId: l.listId,
            name: l.name,
            isSelected: l.isSelected,
            items: l.items.map((it) => it.itemNo),
        })),
    )

export const getDefaultFavs = () =>
    getFavs().then((lists) => {
        for (let i = 0; i < lists.length; i += 1) {
            if (lists[i].isSelected) {
                return lists[i]
            }
        }
        return lists[0]
    })

// Create a new named list. Select=true means it will become the new default list.
export const createFavs = (name, select = true) =>
    spiderpigsQuery(
        SPIDERPIGS_LIST_API,
        `
            mutation($name: String!, $select: Boolean!) {
                createList(name: $name, setSelected: $select) {
                    listId
                }
            }
        `,
        {
            name,
            select,
        },
    ).then((data) => data.createList.listId)

// Add items to a favorites list. If listId is null, add to the selected (default) list.
// If there is no default list currently, this will create it and return the listId.
export const addToFavs = (items, listId = null) =>
    spiderpigsQuery(
        SPIDERPIGS_LIST_API,
        `
            mutation($listId: ID, $items: [AddItemInput!]!) {
                addItems(listId: $listId, items: $items) {
                    listId
                }
            }
        `,
        {
            listId,
            items: items.map((item) => ({
                itemNo: item,
                quantity: 1,
            })),
        },
    ).then(({ data }) => data.addItems.listId)

// Remove items from the favorites list. If listId is null, remove from the selected (default) list.
export const removeFromFavs = (itemNos, listId = null) =>
    spiderpigsQuery(
        SPIDERPIGS_LIST_API,
        `
            mutation($listId: ID, $itemNos: [ID!]!) {
                removeItems(listId: $listId, itemNos: $itemNos) {
                    listId
                }
            }
        `,
        {
            listId,
            itemNos,
        },
    ).then(({ data }) => data.removeItems.listId)

export const getCart = (languageCode) =>
    spiderpigsQuery(
        SPIDERPIGS_CART_API,
        `
            query($languageCode: String!) {
                cart(languageCode: $languageCode) {
                    items {
                        itemNo
                        quantity
                    }
                }
            }
        `,
        {
            languageCode,
        },
    ).then((data) => ({
        items: data.cart.items,
    }))

// Incremental add by quantity.
export const addToCart = (languageCode, items) =>
    spiderpigsQuery(
        SPIDERPIGS_CART_API,
        `
            mutation($languageCode: String!, $items: [AddItemInput!]!) {
                addItems(items: $items, languageCode: $languageCode) {
                    items {
                        itemNo
                        quantity
                    }
                }
            }
        `,
        {
            languageCode,
            items: items.map((item) => ({
                itemNo: item[0],
                quantity: item[1],
            })),
        },
    ).then(({ data }) => ({
        items: data.addItems.items,
    }))

// Set quantity, must be positive, use removeFromCart to "set to 0".
export const updateCart = (languageCode, itemNo, quantity) =>
    spiderpigsQuery(
        SPIDERPIGS_CART_API,
        `
            mutation($languageCode: String!, $items: [UpdateItemInput!]!) {
                updateItems(items: $items, languageCode: $languageCode) {
                    items {
                        itemNo
                        quantity
                    }
                }
            }
        `,
        {
            languageCode,
            items: [
                {
                    itemNo,
                    quantity,
                },
            ],
        },
    ).then((data) => ({
        items: data.updateItems.items,
    }))

// Zero out an item.
export const removeFromCart = (languageCode, itemNo) =>
    spiderpigsQuery(
        SPIDERPIGS_CART_API,
        `
            mutation($languageCode: String!, $items: [ID!]!) {
                removeItems(itemNos: $items, languageCode: $languageCode) {
                    items {
                        itemNo
                        quantity
                    }
                }
            }
        `,
        {
            languageCode,
            items: [itemNo],
        },
    ).then((data) => ({
        items: data.removeItems.items,
    }))
